import { action, observable, makeAutoObservable } from 'mobx';

const INITIAL_FIXED_SLOTS = 9;

class ParticipantsSortStore {
    @observable public fixedSlotsCount = INITIAL_FIXED_SLOTS;
    @observable public sortOrder: string[] = [] as string[];
    // Нужен для Focus/Mobile вида
    @observable public recentSpeakerId: string | null = null;

    public constructor() {
        makeAutoObservable(this);
    }

    @action
    public setSortOrder = (sortOrder: string[]) => {
        this.sortOrder = sortOrder;
    };

    @action
    public setFixedSlotsCount = (fixedSlotsCount: number) => {
        this.fixedSlotsCount = fixedSlotsCount;
    };

    @action
    public pushId = (id: string) => {
        this.sortOrder.push(id);
    };

    @action
    public setRecentSpeakerId = (id: string | null) => {
        this.recentSpeakerId = id;
    };
}

export const participantsSortStore = new ParticipantsSortStore();
